var map = {
	"./avatar-1.png": 273,
	"./avatar-10.png": 670,
	"./avatar-2.png": 646,
	"./avatar-3.png": 671,
	"./avatar-4.png": 647,
	"./avatar-5.png": 648,
	"./avatar-6.png": 640,
	"./avatar-7.png": 672,
	"./avatar-8.png": 673,
	"./avatar-9.png": 674,
	"./avatar-group.png": 1196,
	"./avatar-s1.png": 1197,
	"./avatar-s2.png": 1198,
	"./avatar-thumb-1.png": 1199,
	"./default.png": 1200,
	"./vector-1.png": 1201,
	"./vector-2.png": 1202,
	"./vector-3.png": 1203,
	"./vector-4.png": 1204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 629;